// extracted by mini-css-extract-plugin
export var dropdown = "_v0-0";
export var imageWrapper = "_v0-3";
export var itemNameContainer = "_v0-1";
export var productImage = "_v0-2";
export var spinnerWrapper = "_v0-4";